<template>
    <div class="container">
        <div class="row result-header">
            <h1>{{ resultTitle }}</h1>
            <h2>{{ title }}</h2>
        </div>

        <div class="results row">
            <div
                    class="col-sm result-column"
                    v-bind:key="i"
                    v-for="(result, i) in results"
            >
                <result-progress-bar
                        v-bind:footerText="getResultFooterText(i)"
                        v-bind:index="i"
                        v-bind:percentage="result.percentage"
                />

                <choice class="choice-container"
                        v-bind:format="result.format"
                        v-bind:message="result.message"
                />

                <app-button
                        class="pick-choice-button"
                        v-if="resultType === 'chooseAnswer'"
                        v-on:click.native="pickChoice(i)"
                >Vælg svar
                </app-button>
            </div>
        </div>

        <div class="row continue-button-container">
            <app-button
                    class="pick-choice-button"
                    v-if="resultType === 'noAnswer' || resultType === 'correctAnswer'"
                    v-on:click.native="pickChoice(null)"
            >Videre
            </app-button>
        </div>
    </div>
</template>

<script>
    import AppButton from '@/components/app-button/index'
    import {mapGetters} from 'vuex'
    import Counter from '@/components/counter'
    import ResultProgressBar from './result-progress-bar'
    import Choice from '@/components/choices/choice'

    import PageComponentTemplate from '../page-component-template';

    export default {
        extends: PageComponentTemplate,
        components: {
            Choice,
            AppButton,
            Counter,
            ResultProgressBar
        },
        data() {
            return {
                results: []
            }
        },
        mounted() {
            let results = []

            let voteCounts = this.$gameClient.room.state.voteCounts
            let voteCountsLength = voteCounts.length
            let totalVotes = 0

            for (let i = 0; i < voteCountsLength; i++) {
                totalVotes += voteCounts[i].vote;
            }

            console.log(voteCounts, totalVotes);

            let i = 0

            for (let choice of this.choices) {
                let choiceVotes = 0

                if (voteCountsLength >= i) {
                    choiceVotes = voteCounts[i].vote
                } else {
                    console.warn(`Could not find vote by index ${i}`)

                    choiceVotes = 0 // hmm.. how can that be possible?
                }

                results.push({
                    percentage: totalVotes > 0 ? Math.round((choiceVotes / totalVotes) * 100) : 0,
                    format: choice.format,
                    message: choice.message
                })

                i++
            }

            this.results = results
        },
        computed: {
            ...mapGetters({
                currentCase: 'getCurrentCase',
            }),
            resultTitle() {
                if (this.resultType === 'chooseAnswer') {
                    return 'Resultat - Vælg et fælles svar';
                }

                return 'Resultat - Sådan svarede I';
            },
            choices() {
                return this.options.choices;
            },
            resultType() {
                return this.options.resultType;
            },
            correctIndex() {
                return this.options.correctIndex;
            }
        },
        methods: {
            getResultFooterText(resultIndex) {
                if (this.correctIndex) {
                    return this.correctIndex === resultIndex ? 'RIGTIGT' : '';
                }

                return '';
            },
            pickChoice(choiceIndex) {
                let choice = this.choices[choiceIndex]

                this.$emit('pickChoice', choice);
            }
        }
    }
</script>

<style lang="less" scoped>
    .col-sm {
        &.left-column {
            padding: 0 150px;
        }
    }

    .result-header {
        h1, h2 {
            width: 100%;
        }

        h1 {
            margin-bottom: 10px;
        }
    }

    .counter {
        margin: 30px auto 0 auto;
    }

    .continue-button-container {
        .pick-choice-button {
            margin: 0 auto;
        }
    }

    .result-column {
        text-align: center;

        .pick-choice-button {
            margin-top: 10px;
        }
    }

    .choice-container {
        min-height: 150px;
    }
</style>